import { useState } from 'react';
import { api } from '../../api/client';

interface Terminal {
  id: string;
  description: string | null;
  seller_group_id: number;
  active: boolean;
}

export function TerminalRow({
  terminal,
  onUpdate,
}: {
  terminal: Terminal;
  onUpdate: () => void;
}) {
  const [editing, setEditing] = useState(false);
  const [description, setDescription] = useState(terminal.description || '');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.put(`/wh-terminals/${terminal.id}`, { description });
      if (r.success) {
        setEditing(false);
        onUpdate();
      } else {
        alert('Error: ' + (r.error || 'unknown'));
      }
    } catch (e: any) {
      alert('Error: ' + e.message);
    } finally {
      setSaving(false);
    }
  };

  const toggle = async () => {
    try {
      const r = await api.put(`/wh-terminals/${terminal.id}`, {
        active: !terminal.active,
      });
      if (r.success) {
        onUpdate();
      } else {
        alert('Error: ' + (r.error || 'unknown'));
      }
    } catch (e: any) {
      alert('Error: ' + e.message);
    }
  };

  return (
    <tr className="border-b">
      <td className="p-2 font-mono">{terminal.id}</td>
      <td className="p-2">
        {editing ? (
          <input
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="border p-1 rounded w-full"
          />
        ) : (
          terminal.description || <em className="text-gray-400">sin descripción</em>
        )}
      </td>
      <td className="p-2">{terminal.seller_group_id}</td>
      <td className="p-2">
        <span className={terminal.active ? 'text-green-600' : 'text-gray-400'}>
          {terminal.active ? 'activa' : 'inactiva'}
        </span>
      </td>
      <td className="p-2 text-right space-x-2">
        {editing ? (
          <>
            <button
              onClick={save}
              disabled={saving}
              className="bg-blue-600 text-white px-2 py-1 rounded text-sm disabled:bg-gray-300"
            >
              Guardar
            </button>
            <button
              onClick={() => {
                setEditing(false);
                setDescription(terminal.description || '');
              }}
              className="bg-gray-200 px-2 py-1 rounded text-sm"
            >
              Cancelar
            </button>
          </>
        ) : (
          <>
            <button
              onClick={() => setEditing(true)}
              className="text-blue-600 text-sm hover:underline"
            >
              Editar
            </button>
            <button
              onClick={toggle}
              className="text-orange-600 text-sm hover:underline"
            >
              {terminal.active ? 'Desactivar' : 'Activar'}
            </button>
          </>
        )}
      </td>
    </tr>
  );
}
